import { Refresh } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";
const ResetProfileButton = ({ onReset, email, loading, disabledTooltip }) => {

    return (
        <Tooltip title={disabledTooltip || `Reset profile for ${email}`}>
            <span>
            <Button
                variant="outlined"
                size="small"
                color="primary"
                onClick={onReset}
                disabled={loading || Boolean(disabledTooltip)}
                sx={{
                    fontSize: '10px',
                    textTransform: 'none',
                    borderColor: '#0b756c',
                    color: '#0b756c',
                    minWidth: 90,
                    padding: '2px 10px 2px 6px',
                    height: 32,
                    lineHeight: 1.2,
                    display: 'inline-flex',
                    alignItems: 'center',
                    '& .MuiButton-startIcon': {
                        minWidth: 0,
                        marginRight: 6,
                    },
                    '&:hover': {
                        borderColor: '#0b756c',
                        backgroundColor: 'rgba(11, 117, 108, 0.04)',
                    },
                }}
            > <Refresh sx={{ fontSize: 14, minWidth: 0, marginRight: 0.5 }} />
                {(loading) ? "Resetting..." : "Reset Profile"}
            </Button>
            </span>
        </Tooltip>
    );
};

export default ResetProfileButton;